<template>
  <div class="wt-custom-overlay-field">
    <component :is="componentName" :field="field" @change="valueChanged">
    </component>
  </div>
</template>

<script>
import FieldDropdown from 'AssetEditor/functionality/CustomOverlays/fields/FieldDropdown.vue';

export default {
  name: 'CollageCustomOverlayField',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    componentName() {
      return 'field-' + (_.kebabCase(this.field.type) || '').toLowerCase();
    },
  },
  components: {
    FieldDropdown,
  },
  methods: {
    valueChanged(e) {
      this.$emit('change', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-custom-overlay-field {
  margin-bottom: 0;
}
</style>
